/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  PayoutEntriesList,
  PayoutEntriesParams,
  PayoutEntry,
  PayoutEntryCreateInput,
  PayoutEntryDeclineInput,
  PayoutEntryUpdateInput,
  PayoutLedger,
  PayoutLedgerCreateInput,
  PayoutParticipant,
  PayoutParticipantCreateInput,
  PayoutParticipantUpdateInput,
  PayoutParticipantsList,
  PayoutSettlement,
  PayoutTransfer,
  PayoutTransfersList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Open a payout ledger on a fulfilled fleet contract
 */
export const createFleetContractPayoutLedger = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    payoutLedgerCreateInput?: MaybeRefOrGetter<PayoutLedgerCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
payoutLedgerCreateInput = toValue(payoutLedgerCreateInput);

      return axiosClient<PayoutLedger>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/payouts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payoutLedgerCreateInput, signal
    },
      );
    }




export const getCreateFleetContractPayoutLedgerMutationKey = () => ['createFleetContractPayoutLedger'] as const;

export const getCreateFleetContractPayoutLedgerMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetContractPayoutLedger>>, TError,CreateFleetContractPayoutLedgerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetContractPayoutLedger>>, TError,CreateFleetContractPayoutLedgerMutationVariables, TContext> => {

const mutationKey = getCreateFleetContractPayoutLedgerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetContractPayoutLedger>>, CreateFleetContractPayoutLedgerMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,data} = props ?? {};

          return  createFleetContractPayoutLedger(fleetSlug,fleetContractSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetContractPayoutLedgerMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetContractPayoutLedger>>>
    export type CreateFleetContractPayoutLedgerMutationBody = PayoutLedgerCreateInput | undefined
    export type CreateFleetContractPayoutLedgerMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetContractPayoutLedgerMutationVariables = {fleetSlug: string;fleetContractSlug: string;data?: PayoutLedgerCreateInput}

    /**
 * @summary Open a payout ledger on a fulfilled fleet contract
 */
export const useCreateFleetContractPayoutLedger = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetContractPayoutLedger>>, TError,CreateFleetContractPayoutLedgerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetContractPayoutLedger>>,
        TError,
        CreateFleetContractPayoutLedgerMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetContractPayoutLedgerMutationOptions(options), queryClient);
    }
    /**
 * @summary Show the payout ledger of a fleet contract
 */
export const fleetContractPayoutLedger = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);

      return axiosClient<PayoutLedger>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/payouts`, method: 'GET', signal
    },
      );
    }




export const getFleetContractPayoutLedgerQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'contracts',fleetContractSlug,'payouts'
    ] as const;
    }


export const getFleetContractPayoutLedgerQueryOptions = <TData = Awaited<ReturnType<typeof fleetContractPayoutLedger>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContractPayoutLedger>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetContractPayoutLedgerQueryKey(fleetSlug,fleetContractSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetContractPayoutLedger>>> = ({ signal }) => fleetContractPayoutLedger(fleetSlug,fleetContractSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetContractSlug) !== null && toValue(fleetContractSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetContractPayoutLedger>>, TError, TData>
}

export type FleetContractPayoutLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof fleetContractPayoutLedger>>>
export type FleetContractPayoutLedgerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show the payout ledger of a fleet contract
 */

export function useFleetContractPayoutLedger<TData = Awaited<ReturnType<typeof fleetContractPayoutLedger>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContractPayoutLedger>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetContractPayoutLedgerQueryOptions(fleetSlug,fleetContractSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Open a payout ledger on a fleet event
 */
export const createFleetEventPayoutLedger = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    payoutLedgerCreateInput?: MaybeRefOrGetter<PayoutLedgerCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
payoutLedgerCreateInput = toValue(payoutLedgerCreateInput);

      return axiosClient<PayoutLedger>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/payouts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payoutLedgerCreateInput, signal
    },
      );
    }




export const getCreateFleetEventPayoutLedgerMutationKey = () => ['createFleetEventPayoutLedger'] as const;

export const getCreateFleetEventPayoutLedgerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventPayoutLedger>>, TError,CreateFleetEventPayoutLedgerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEventPayoutLedger>>, TError,CreateFleetEventPayoutLedgerMutationVariables, TContext> => {

const mutationKey = getCreateFleetEventPayoutLedgerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEventPayoutLedger>>, CreateFleetEventPayoutLedgerMutationVariables> = (props) => {
          const {fleetSlug,fleetEventSlug,data} = props ?? {};

          return  createFleetEventPayoutLedger(fleetSlug,fleetEventSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventPayoutLedgerMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEventPayoutLedger>>>
    export type CreateFleetEventPayoutLedgerMutationBody = PayoutLedgerCreateInput | undefined
    export type CreateFleetEventPayoutLedgerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetEventPayoutLedgerMutationVariables = {fleetSlug: string;fleetEventSlug: string;data?: PayoutLedgerCreateInput}

    /**
 * @summary Open a payout ledger on a fleet event
 */
export const useCreateFleetEventPayoutLedger = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventPayoutLedger>>, TError,CreateFleetEventPayoutLedgerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEventPayoutLedger>>,
        TError,
        CreateFleetEventPayoutLedgerMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetEventPayoutLedgerMutationOptions(options), queryClient);
    }
    /**
 * @summary Show the payout ledger of a fleet event
 */
export const fleetEventPayoutLedger = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);

      return axiosClient<PayoutLedger>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/payouts`, method: 'GET', signal
    },
      );
    }




export const getFleetEventPayoutLedgerQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'events',fleetEventSlug,'payouts'
    ] as const;
    }


export const getFleetEventPayoutLedgerQueryOptions = <TData = Awaited<ReturnType<typeof fleetEventPayoutLedger>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEventPayoutLedger>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetEventPayoutLedgerQueryKey(fleetSlug,fleetEventSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetEventPayoutLedger>>> = ({ signal }) => fleetEventPayoutLedger(fleetSlug,fleetEventSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetEventSlug) !== null && toValue(fleetEventSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetEventPayoutLedger>>, TError, TData>
}

export type FleetEventPayoutLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof fleetEventPayoutLedger>>>
export type FleetEventPayoutLedgerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show the payout ledger of a fleet event
 */

export function useFleetEventPayoutLedger<TData = Awaited<ReturnType<typeof fleetEventPayoutLedger>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEventPayoutLedger>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetEventPayoutLedgerQueryOptions(fleetSlug,fleetEventSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Show a payout ledger
 */
export const payoutLedger = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PayoutLedger>(
      {url: `/payouts/${id}`, method: 'GET', signal
    },
      );
    }




export const getPayoutLedgerQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'payouts',id
    ] as const;
    }


export const getPayoutLedgerQueryOptions = <TData = Awaited<ReturnType<typeof payoutLedger>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutLedger>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPayoutLedgerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof payoutLedger>>> = ({ signal }) => payoutLedger(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof payoutLedger>>, TError, TData>
}

export type PayoutLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof payoutLedger>>>
export type PayoutLedgerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show a payout ledger
 */

export function usePayoutLedger<TData = Awaited<ReturnType<typeof payoutLedger>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutLedger>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPayoutLedgerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Balances and the transfers that settle them
 */
export const payoutLedgerBalances = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PayoutSettlement>(
      {url: `/payouts/${id}/balances`, method: 'GET', signal
    },
      );
    }




export const getPayoutLedgerBalancesQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'payouts',id,'balances'
    ] as const;
    }


export const getPayoutLedgerBalancesQueryOptions = <TData = Awaited<ReturnType<typeof payoutLedgerBalances>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutLedgerBalances>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPayoutLedgerBalancesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof payoutLedgerBalances>>> = ({ signal }) => payoutLedgerBalances(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof payoutLedgerBalances>>, TError, TData>
}

export type PayoutLedgerBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof payoutLedgerBalances>>>
export type PayoutLedgerBalancesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Balances and the transfers that settle them
 */

export function usePayoutLedgerBalances<TData = Awaited<ReturnType<typeof payoutLedgerBalances>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutLedgerBalances>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPayoutLedgerBalancesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Reopen a settled payout ledger
 */
export const reopenPayoutLedger = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PayoutLedger>(
      {url: `/payouts/${id}/reopen`, method: 'PUT', signal
    },
      );
    }




export const getReopenPayoutLedgerMutationKey = () => ['reopenPayoutLedger'] as const;

export const getReopenPayoutLedgerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenPayoutLedger>>, TError,ReopenPayoutLedgerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reopenPayoutLedger>>, TError,ReopenPayoutLedgerMutationVariables, TContext> => {

const mutationKey = getReopenPayoutLedgerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenPayoutLedger>>, ReopenPayoutLedgerMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reopenPayoutLedger(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenPayoutLedgerMutationResult = NonNullable<Awaited<ReturnType<typeof reopenPayoutLedger>>>

    export type ReopenPayoutLedgerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReopenPayoutLedgerMutationVariables = {id: string}

    /**
 * @summary Reopen a settled payout ledger
 */
export const useReopenPayoutLedger = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenPayoutLedger>>, TError,ReopenPayoutLedgerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reopenPayoutLedger>>,
        TError,
        ReopenPayoutLedgerMutationVariables,
        TContext
      > => {
      return useMutation(getReopenPayoutLedgerMutationOptions(options), queryClient);
    }
    /**
 * @summary Settle a payout ledger
 */
export const settlePayoutLedger = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PayoutLedger>(
      {url: `/payouts/${id}/settle`, method: 'PUT', signal
    },
      );
    }




export const getSettlePayoutLedgerMutationKey = () => ['settlePayoutLedger'] as const;

export const getSettlePayoutLedgerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settlePayoutLedger>>, TError,SettlePayoutLedgerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof settlePayoutLedger>>, TError,SettlePayoutLedgerMutationVariables, TContext> => {

const mutationKey = getSettlePayoutLedgerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settlePayoutLedger>>, SettlePayoutLedgerMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  settlePayoutLedger(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettlePayoutLedgerMutationResult = NonNullable<Awaited<ReturnType<typeof settlePayoutLedger>>>

    export type SettlePayoutLedgerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SettlePayoutLedgerMutationVariables = {id: string}

    /**
 * @summary Settle a payout ledger
 */
export const useSettlePayoutLedger = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settlePayoutLedger>>, TError,SettlePayoutLedgerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settlePayoutLedger>>,
        TError,
        SettlePayoutLedgerMutationVariables,
        TContext
      > => {
      return useMutation(getSettlePayoutLedgerMutationOptions(options), queryClient);
    }
    /**
 * @summary Record a payout entry
 */
export const createPayoutEntry = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    payoutEntryCreateInput: MaybeRefOrGetter<PayoutEntryCreateInput>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
payoutEntryCreateInput = toValue(payoutEntryCreateInput);

      return axiosClient<PayoutEntry>(
      {url: `/payouts/${payoutLedgerId}/entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payoutEntryCreateInput, signal
    },
      );
    }




export const getCreatePayoutEntryMutationKey = () => ['createPayoutEntry'] as const;

export const getCreatePayoutEntryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayoutEntry>>, TError,CreatePayoutEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPayoutEntry>>, TError,CreatePayoutEntryMutationVariables, TContext> => {

const mutationKey = getCreatePayoutEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPayoutEntry>>, CreatePayoutEntryMutationVariables> = (props) => {
          const {payoutLedgerId,data} = props ?? {};

          return  createPayoutEntry(payoutLedgerId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePayoutEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createPayoutEntry>>>
    export type CreatePayoutEntryMutationBody = PayoutEntryCreateInput
    export type CreatePayoutEntryMutationError = ErrorType<ValidationError | StandardError>
    export type CreatePayoutEntryMutationVariables = {payoutLedgerId: string;data: PayoutEntryCreateInput}

    /**
 * @summary Record a payout entry
 */
export const useCreatePayoutEntry = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayoutEntry>>, TError,CreatePayoutEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPayoutEntry>>,
        TError,
        CreatePayoutEntryMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePayoutEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary List payout entries
 */
export const payoutEntries = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PayoutEntriesParams>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
params = toValue(params);

      return axiosClient<PayoutEntriesList>(
      {url: `/payouts/${payoutLedgerId}/entries`, method: 'GET',
        params, signal
    },
      );
    }




export const getPayoutEntriesQueryKey = (payoutLedgerId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PayoutEntriesParams>,) => {
    return [
    'payouts',payoutLedgerId,'entries', ...(params ? [params] : [])
    ] as const;
    }


export const getPayoutEntriesQueryOptions = <TData = Awaited<ReturnType<typeof payoutEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(payoutLedgerId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PayoutEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPayoutEntriesQueryKey(payoutLedgerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof payoutEntries>>> = ({ signal }) => payoutEntries(payoutLedgerId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(payoutLedgerId) !== null && toValue(payoutLedgerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof payoutEntries>>, TError, TData>
}

export type PayoutEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof payoutEntries>>>
export type PayoutEntriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List payout entries
 */

export function usePayoutEntries<TData = Awaited<ReturnType<typeof payoutEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 payoutLedgerId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PayoutEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPayoutEntriesQueryOptions(payoutLedgerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update a payout entry
 */
export const updatePayoutEntry = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    payoutEntryUpdateInput: MaybeRefOrGetter<PayoutEntryUpdateInput>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);
payoutEntryUpdateInput = toValue(payoutEntryUpdateInput);

      return axiosClient<PayoutEntry>(
      {url: `/payouts/${payoutLedgerId}/entries/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payoutEntryUpdateInput, signal
    },
      );
    }




export const getUpdatePayoutEntryMutationKey = () => ['updatePayoutEntry'] as const;

export const getUpdatePayoutEntryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayoutEntry>>, TError,UpdatePayoutEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePayoutEntry>>, TError,UpdatePayoutEntryMutationVariables, TContext> => {

const mutationKey = getUpdatePayoutEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayoutEntry>>, UpdatePayoutEntryMutationVariables> = (props) => {
          const {payoutLedgerId,id,data} = props ?? {};

          return  updatePayoutEntry(payoutLedgerId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayoutEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayoutEntry>>>
    export type UpdatePayoutEntryMutationBody = PayoutEntryUpdateInput
    export type UpdatePayoutEntryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdatePayoutEntryMutationVariables = {payoutLedgerId: string;id: string;data: PayoutEntryUpdateInput}

    /**
 * @summary Update a payout entry
 */
export const useUpdatePayoutEntry = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayoutEntry>>, TError,UpdatePayoutEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePayoutEntry>>,
        TError,
        UpdatePayoutEntryMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePayoutEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a payout entry
 */
export const destroyPayoutEntry = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);

      return axiosClient<PayoutEntry>(
      {url: `/payouts/${payoutLedgerId}/entries/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyPayoutEntryMutationKey = () => ['destroyPayoutEntry'] as const;

export const getDestroyPayoutEntryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyPayoutEntry>>, TError,DestroyPayoutEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyPayoutEntry>>, TError,DestroyPayoutEntryMutationVariables, TContext> => {

const mutationKey = getDestroyPayoutEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyPayoutEntry>>, DestroyPayoutEntryMutationVariables> = (props) => {
          const {payoutLedgerId,id} = props ?? {};

          return  destroyPayoutEntry(payoutLedgerId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyPayoutEntryMutationResult = NonNullable<Awaited<ReturnType<typeof destroyPayoutEntry>>>

    export type DestroyPayoutEntryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyPayoutEntryMutationVariables = {payoutLedgerId: string;id: string}

    /**
 * @summary Delete a payout entry
 */
export const useDestroyPayoutEntry = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyPayoutEntry>>, TError,DestroyPayoutEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyPayoutEntry>>,
        TError,
        DestroyPayoutEntryMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyPayoutEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary Approve a payout expense
 */
export const approvePayoutEntry = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);

      return axiosClient<PayoutEntry>(
      {url: `/payouts/${payoutLedgerId}/entries/${id}/approve`, method: 'PUT', signal
    },
      );
    }




export const getApprovePayoutEntryMutationKey = () => ['approvePayoutEntry'] as const;

export const getApprovePayoutEntryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePayoutEntry>>, TError,ApprovePayoutEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approvePayoutEntry>>, TError,ApprovePayoutEntryMutationVariables, TContext> => {

const mutationKey = getApprovePayoutEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePayoutEntry>>, ApprovePayoutEntryMutationVariables> = (props) => {
          const {payoutLedgerId,id} = props ?? {};

          return  approvePayoutEntry(payoutLedgerId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePayoutEntryMutationResult = NonNullable<Awaited<ReturnType<typeof approvePayoutEntry>>>

    export type ApprovePayoutEntryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ApprovePayoutEntryMutationVariables = {payoutLedgerId: string;id: string}

    /**
 * @summary Approve a payout expense
 */
export const useApprovePayoutEntry = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePayoutEntry>>, TError,ApprovePayoutEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof approvePayoutEntry>>,
        TError,
        ApprovePayoutEntryMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePayoutEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline a payout expense
 */
export const declinePayoutEntry = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    payoutEntryDeclineInput?: MaybeRefOrGetter<PayoutEntryDeclineInput>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);
payoutEntryDeclineInput = toValue(payoutEntryDeclineInput);

      return axiosClient<PayoutEntry>(
      {url: `/payouts/${payoutLedgerId}/entries/${id}/decline`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: payoutEntryDeclineInput, signal
    },
      );
    }




export const getDeclinePayoutEntryMutationKey = () => ['declinePayoutEntry'] as const;

export const getDeclinePayoutEntryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declinePayoutEntry>>, TError,DeclinePayoutEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declinePayoutEntry>>, TError,DeclinePayoutEntryMutationVariables, TContext> => {

const mutationKey = getDeclinePayoutEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declinePayoutEntry>>, DeclinePayoutEntryMutationVariables> = (props) => {
          const {payoutLedgerId,id,data} = props ?? {};

          return  declinePayoutEntry(payoutLedgerId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclinePayoutEntryMutationResult = NonNullable<Awaited<ReturnType<typeof declinePayoutEntry>>>
    export type DeclinePayoutEntryMutationBody = PayoutEntryDeclineInput | undefined
    export type DeclinePayoutEntryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DeclinePayoutEntryMutationVariables = {payoutLedgerId: string;id: string;data?: PayoutEntryDeclineInput}

    /**
 * @summary Decline a payout expense
 */
export const useDeclinePayoutEntry = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declinePayoutEntry>>, TError,DeclinePayoutEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declinePayoutEntry>>,
        TError,
        DeclinePayoutEntryMutationVariables,
        TContext
      > => {
      return useMutation(getDeclinePayoutEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary Add a payout participant
 */
export const createPayoutParticipant = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    payoutParticipantCreateInput: MaybeRefOrGetter<PayoutParticipantCreateInput>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
payoutParticipantCreateInput = toValue(payoutParticipantCreateInput);

      return axiosClient<PayoutParticipant>(
      {url: `/payouts/${payoutLedgerId}/participants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payoutParticipantCreateInput, signal
    },
      );
    }




export const getCreatePayoutParticipantMutationKey = () => ['createPayoutParticipant'] as const;

export const getCreatePayoutParticipantMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayoutParticipant>>, TError,CreatePayoutParticipantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPayoutParticipant>>, TError,CreatePayoutParticipantMutationVariables, TContext> => {

const mutationKey = getCreatePayoutParticipantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPayoutParticipant>>, CreatePayoutParticipantMutationVariables> = (props) => {
          const {payoutLedgerId,data} = props ?? {};

          return  createPayoutParticipant(payoutLedgerId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePayoutParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof createPayoutParticipant>>>
    export type CreatePayoutParticipantMutationBody = PayoutParticipantCreateInput
    export type CreatePayoutParticipantMutationError = ErrorType<ValidationError | StandardError>
    export type CreatePayoutParticipantMutationVariables = {payoutLedgerId: string;data: PayoutParticipantCreateInput}

    /**
 * @summary Add a payout participant
 */
export const useCreatePayoutParticipant = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayoutParticipant>>, TError,CreatePayoutParticipantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPayoutParticipant>>,
        TError,
        CreatePayoutParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePayoutParticipantMutationOptions(options), queryClient);
    }
    /**
 * @summary List payout participants
 */
export const payoutParticipants = (
    payoutLedgerId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);

      return axiosClient<PayoutParticipantsList>(
      {url: `/payouts/${payoutLedgerId}/participants`, method: 'GET', signal
    },
      );
    }




export const getPayoutParticipantsQueryKey = (payoutLedgerId: MaybeRefOrGetter<string>,) => {
    return [
    'payouts',payoutLedgerId,'participants'
    ] as const;
    }


export const getPayoutParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof payoutParticipants>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(payoutLedgerId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutParticipants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPayoutParticipantsQueryKey(payoutLedgerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof payoutParticipants>>> = ({ signal }) => payoutParticipants(payoutLedgerId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(payoutLedgerId) !== null && toValue(payoutLedgerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof payoutParticipants>>, TError, TData>
}

export type PayoutParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof payoutParticipants>>>
export type PayoutParticipantsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List payout participants
 */

export function usePayoutParticipants<TData = Awaited<ReturnType<typeof payoutParticipants>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 payoutLedgerId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPayoutParticipantsQueryOptions(payoutLedgerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update a payout participant
 */
export const updatePayoutParticipant = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    payoutParticipantUpdateInput: MaybeRefOrGetter<PayoutParticipantUpdateInput>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);
payoutParticipantUpdateInput = toValue(payoutParticipantUpdateInput);

      return axiosClient<PayoutParticipant>(
      {url: `/payouts/${payoutLedgerId}/participants/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payoutParticipantUpdateInput, signal
    },
      );
    }




export const getUpdatePayoutParticipantMutationKey = () => ['updatePayoutParticipant'] as const;

export const getUpdatePayoutParticipantMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayoutParticipant>>, TError,UpdatePayoutParticipantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePayoutParticipant>>, TError,UpdatePayoutParticipantMutationVariables, TContext> => {

const mutationKey = getUpdatePayoutParticipantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayoutParticipant>>, UpdatePayoutParticipantMutationVariables> = (props) => {
          const {payoutLedgerId,id,data} = props ?? {};

          return  updatePayoutParticipant(payoutLedgerId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayoutParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayoutParticipant>>>
    export type UpdatePayoutParticipantMutationBody = PayoutParticipantUpdateInput
    export type UpdatePayoutParticipantMutationError = ErrorType<ValidationError | StandardError>
    export type UpdatePayoutParticipantMutationVariables = {payoutLedgerId: string;id: string;data: PayoutParticipantUpdateInput}

    /**
 * @summary Update a payout participant
 */
export const useUpdatePayoutParticipant = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayoutParticipant>>, TError,UpdatePayoutParticipantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePayoutParticipant>>,
        TError,
        UpdatePayoutParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePayoutParticipantMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove a payout participant
 */
export const destroyPayoutParticipant = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);

      return axiosClient<PayoutParticipant>(
      {url: `/payouts/${payoutLedgerId}/participants/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyPayoutParticipantMutationKey = () => ['destroyPayoutParticipant'] as const;

export const getDestroyPayoutParticipantMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyPayoutParticipant>>, TError,DestroyPayoutParticipantMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyPayoutParticipant>>, TError,DestroyPayoutParticipantMutationVariables, TContext> => {

const mutationKey = getDestroyPayoutParticipantMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyPayoutParticipant>>, DestroyPayoutParticipantMutationVariables> = (props) => {
          const {payoutLedgerId,id} = props ?? {};

          return  destroyPayoutParticipant(payoutLedgerId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyPayoutParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof destroyPayoutParticipant>>>

    export type DestroyPayoutParticipantMutationError = ErrorType<ValidationError | StandardError>
    export type DestroyPayoutParticipantMutationVariables = {payoutLedgerId: string;id: string}

    /**
 * @summary Remove a payout participant
 */
export const useDestroyPayoutParticipant = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyPayoutParticipant>>, TError,DestroyPayoutParticipantMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyPayoutParticipant>>,
        TError,
        DestroyPayoutParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyPayoutParticipantMutationOptions(options), queryClient);
    }
    /**
 * @summary The frozen payout list
 */
export const payoutTransfers = (
    payoutLedgerId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);

      return axiosClient<PayoutTransfersList>(
      {url: `/payouts/${payoutLedgerId}/transfers`, method: 'GET', signal
    },
      );
    }




export const getPayoutTransfersQueryKey = (payoutLedgerId: MaybeRefOrGetter<string>,) => {
    return [
    'payouts',payoutLedgerId,'transfers'
    ] as const;
    }


export const getPayoutTransfersQueryOptions = <TData = Awaited<ReturnType<typeof payoutTransfers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(payoutLedgerId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutTransfers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPayoutTransfersQueryKey(payoutLedgerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof payoutTransfers>>> = ({ signal }) => payoutTransfers(payoutLedgerId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(payoutLedgerId) !== null && toValue(payoutLedgerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof payoutTransfers>>, TError, TData>
}

export type PayoutTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof payoutTransfers>>>
export type PayoutTransfersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary The frozen payout list
 */

export function usePayoutTransfers<TData = Awaited<ReturnType<typeof payoutTransfers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 payoutLedgerId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payoutTransfers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPayoutTransfersQueryOptions(payoutLedgerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mark a transfer as paid
 */
export const confirmPayoutTransfer = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);

      return axiosClient<PayoutTransfer>(
      {url: `/payouts/${payoutLedgerId}/transfers/${id}/confirm`, method: 'PUT', signal
    },
      );
    }




export const getConfirmPayoutTransferMutationKey = () => ['confirmPayoutTransfer'] as const;

export const getConfirmPayoutTransferMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPayoutTransfer>>, TError,ConfirmPayoutTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmPayoutTransfer>>, TError,ConfirmPayoutTransferMutationVariables, TContext> => {

const mutationKey = getConfirmPayoutTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPayoutTransfer>>, ConfirmPayoutTransferMutationVariables> = (props) => {
          const {payoutLedgerId,id} = props ?? {};

          return  confirmPayoutTransfer(payoutLedgerId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPayoutTransferMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPayoutTransfer>>>

    export type ConfirmPayoutTransferMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ConfirmPayoutTransferMutationVariables = {payoutLedgerId: string;id: string}

    /**
 * @summary Mark a transfer as paid
 */
export const useConfirmPayoutTransfer = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPayoutTransfer>>, TError,ConfirmPayoutTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmPayoutTransfer>>,
        TError,
        ConfirmPayoutTransferMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmPayoutTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Undo a confirmation
 */
export const unconfirmPayoutTransfer = (
    payoutLedgerId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      payoutLedgerId = toValue(payoutLedgerId);
id = toValue(id);

      return axiosClient<PayoutTransfer>(
      {url: `/payouts/${payoutLedgerId}/transfers/${id}/confirm`, method: 'DELETE', signal
    },
      );
    }




export const getUnconfirmPayoutTransferMutationKey = () => ['unconfirmPayoutTransfer'] as const;

export const getUnconfirmPayoutTransferMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unconfirmPayoutTransfer>>, TError,UnconfirmPayoutTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unconfirmPayoutTransfer>>, TError,UnconfirmPayoutTransferMutationVariables, TContext> => {

const mutationKey = getUnconfirmPayoutTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unconfirmPayoutTransfer>>, UnconfirmPayoutTransferMutationVariables> = (props) => {
          const {payoutLedgerId,id} = props ?? {};

          return  unconfirmPayoutTransfer(payoutLedgerId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnconfirmPayoutTransferMutationResult = NonNullable<Awaited<ReturnType<typeof unconfirmPayoutTransfer>>>

    export type UnconfirmPayoutTransferMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnconfirmPayoutTransferMutationVariables = {payoutLedgerId: string;id: string}

    /**
 * @summary Undo a confirmation
 */
export const useUnconfirmPayoutTransfer = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unconfirmPayoutTransfer>>, TError,UnconfirmPayoutTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unconfirmPayoutTransfer>>,
        TError,
        UnconfirmPayoutTransferMutationVariables,
        TContext
      > => {
      return useMutation(getUnconfirmPayoutTransferMutationOptions(options), queryClient);
    }
